﻿import React from 'react';
import { connect } from 'react-redux';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import VeilederLutDto from '../Models/VeilederLutDto';
import { VeilederLutAppState } from '../Store';
import { ResultatValg } from '../Store/Resultat/Types';
import * as Ids from './../Ids';
import * as LutApi from './../Utilities/LutApi';
import { Larested } from './ResultatAComponent';

interface ResultatOwnProps {
    larested: Larested;
}

type ResultatDisplayProps = ResultatOwnProps & MapStateToProps;

function EkstraboksComponent(props: ResultatDisplayProps): JSX.Element {
    const { epiContext, larested } = props;
    return (
        <div
            id={Ids.BoksEkstraboks}
            className="c-veileder__panel c-veileder__panel--info c-veileder__panel--ekstraboks c-veileder__panel--white-aubergine"
        >
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--ekstraboks-fullwidth c-veileder__content--absolutt-midtstilt">
                    <h3 className="c-veileder__content--header c-veileder__tittel c-veileder__tittel--resultat">
                        {contentResolver(epiContext, 'tittelEkstraboks')}
                    </h3>
                    <div className="c-veileder__content--textarea">
                        <p>{contentResolver(epiContext, 'infoEkstraboks')}</p>
                    </div>

                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--ekstraboks-fullwidth c-veileder__content--ekstraboks-table-wrapper">
                    <div className="c-veileder__content--ekstraboks-table">
                        <div role="table" className="c-table">
                            <div role="row" className="c-table__header-row">
                                <div role="columnheader" className="c-table__header-cell ">{contentResolver(epiContext, 'overskriftTabellEkstraboks')}</div>
                            </div>
                            {
                                larested?.UtdanningListe?.map((utdanning: LutApi.UtdanningViewModel, i: number) => {
                                    return (
                                        <div key={i} role="row" className="c-table__data-row">
                                            <div role="cell" className="c-table__data-cell">
                                              {utdanning.Sprakvarianter.find(s => s.SprakKode === epiContext.epiModel?.language.name)?.Navn}
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
            {larested.LarestedWebAdresse &&
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--ekstraboks-fullwidth">
                        <div className="c-veileder__linkwrapper">
                            <a className="c-knapp c-knapp--lenke c-knapp--artikkellenke c-knapp--icon-after c-knapp--pil-hoyre-aubergine" href={larested.LarestedWebAdresse}>
                                {contentResolver(epiContext, 'lenketekstEkstraboks')}
                            </a>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederLutDto>;
    resultat: ResultatValg;
}

export default connect(
    (state: VeilederLutAppState, ownProps: ResultatOwnProps): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            resultat: state.resultat,
        };
    }
)(EkstraboksComponent);
